import { ClientGroupType, ClientGroupTypeOptions } from 'models/flexible/ClientGroupType';
import http from 'services/http';

const URL = 'admin/client_group_types';

export async function adminUpdateClientGroupType(id: string, data: Record<string, any>): Promise<ClientGroupType> {
  return http.patch<ClientGroupTypeOptions>(`${URL}/${id}`, data).then((res) => new ClientGroupType(res.data));
}
